"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var selectDefaultListId = function selectDefaultListId(data) {
  var _data$objects;
  return data === null || data === void 0 || (_data$objects = data.objects) === null || _data$objects === void 0 || (_data$objects = _data$objects[0]) === null || _data$objects === void 0 ? void 0 : _data$objects.id;
}; // hardcode to select the first list always. We query by country/marketplace which should only have one list
var _default = exports["default"] = selectDefaultListId;